import { BuilderContentType } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/content/BuilderContentType';
export class SendMessageFromHttpActionSettings {
    constructor() {
        this.headers = {};
        this.$builderType = BuilderContentType.SelectImmediate;
        this.type = 'application/vnd.lime.select+json';
    }
}
